export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT = 'LOGOUT';

export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const OPEN_TYPE_SELECTION_MODAL = 'OPEN_TYPE_SELECTION_MODAL';
export const CLOSE_TYPE_SELECTION_MODAL = 'CLOSE_TYPE_SELECTION_MODAL';

export const QUIZ_DATA_ON_SUBMIT_SUCCESS = 'QUIZ_DATA_ON_SUBMIT_SUCCESS';
export const QUIZ_DATA_ON_SUBMIT_FAIL = 'QUIZ_DATA_ON_SUBMIT_FAIL';

export const QUIZ_SUBMIT_HANDLER_SUCCESS = 'QUIZ_SUBMIT_HANDLER_SUCCESS';
export const QUIZ_SUBMIT_HANDLER_FAIL = 'QUIZ_SUBMIT_HANDLER_FAIL';

export const CATEGORY_FECTH_SUCCESS = 'CATEGORY_FECTH_SUCCESS';
export const CATEGORY_FECTH_FAIL = 'CATEGORY_FECTH_FAIL';

export const LEADERBOARD_FETCH_SUCCESS = 'LEADERBOARD_FETCH_SUCCESS';
export const LEADERBOARD_FETCH_FAIL = 'LEADERBOARD_FETCH_FAIL';

export const RAZORPAY_ORDER_SUCCESS = 'RAZORPAY_ORDER_SUCCESS';

export const CLOSE_PAYMENT_MODAL = 'CLOSE_PAYMENT_MODAL';

export const SET_LOGIN_MODAL = 'SET_LOGIN_MODAL';
export const CLOSE_LOGIN_MODAL = 'CLOSE_LOGIN_MODAL';

export const UPDATE_PREMIUM_PLAN = 'UPDATE_PREMIUM_PLAN';